module.exports = __webpack_public_path__ + "img/posterSearch-des9.06cddbd9.png";